import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46f5e508"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "application-volume" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "progress-bar" }
const _hoisted_5 = { class: "on" }
const _hoisted_6 = { class: "proportion" }

import { ref, onMounted, onUnmounted, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useHomeDataStore } from '@/pinia/useHomeDataStore'
import TitleCpn from '../../../Title/TitleCpn.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationVolume',
  setup(__props) {

let scrolltimer = 0
const homeDataStore = useHomeDataStore()
const { data } = storeToRefs(homeDataStore)
const scrolltRef = ref<HTMLElement>()
watch(
    () => data.value,
    (v) => {
        if (scrolltimer) return

        if (v) {
            console.log(1);

            automaticScrolling()
        }
    },
    { flush: "post" }
)
onMounted(() => {
    // 获取最新的DOM信息并进行相应的操作
    automaticScrolling()
})

onUnmounted(() => {
    clearInterval(scrolltimer)
})

const automaticScrolling = () => {
    if (scrolltRef.value) {
        if (scrolltRef.value.scrollHeight <= scrolltRef.value.clientHeight) {
            return
        }
        scrolltimer = setInterval(() => {
            if (scrolltRef.value) {
                if (scrolltRef.value.scrollTop >= scrolltRef.value.scrollHeight - scrolltRef.value.clientHeight) {
                    scrolltRef.value.scrollTo(0, 0)
                }
                scrolltRef.value.scrollTo(0, scrolltRef.value.scrollTop + 1)
            }
        }, 100)
    }
}

const handleMouseEnter = () => {
    clearInterval(scrolltimer)
}

const handleMouseLeave = () => {
    automaticScrolling()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleCpn, { title: "申请量排名" }),
    _createElementVNode("div", {
      class: "contemt",
      ref_key: "scrolltRef",
      ref: scrolltRef,
      onMouseenter: handleMouseEnter,
      onMouseleave: handleMouseLeave
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data)?.left2, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row",
          key: item.id
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["ranking", [item.ranking < 4 ? 'yellow' : 'gradient']])
          }, [
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(item.ranking), 1)
          ], 2),
          _createElementVNode("div", _hoisted_3, _toDisplayString(item.city), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              style: _normalizeStyle({ width: `${item.proportion}%` })
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(item.number), 1),
          _createElementVNode("div", _hoisted_6, "占比" + _toDisplayString(item.proportion) + "%", 1)
        ]))
      }), 128))
    ], 544)
  ]))
}
}

})